<template>
  <Accordion title="Dados do Depósito">
    <div class="grid grid-cols-4 gap-3">
      <Select v-if="!routeInfo.params.id" :items="type" v-model="localValue.type" label="Tipo" required :error="localErrors.type" />
      <InputText :disabled="disabled" v-model="localValue.name" label="Nome do Depósito" :error="localErrors.name" required placeholder="Insira o Nome do Depósito" />
      <InputCep :disabled="disabled" v-if="!routeInfo.params.id" v-model="localValue.cep" label="CEP" :error="localErrors.cep" placeholder="Insira o CEP" />
      <InputText :disabled="disabled" v-model="localValue.address" label="Endereço" :error="localErrors.address" placeholder="Insira o endereço" />
      <InputText :disabled="disabled" v-model="localValue.neighborhood" label="Bairro" :error="localErrors.neighborhood" placeholder="Insira o bairro" />
      <InputZoom
        :disabled="disabled"
        label="Localidade"
        database="local"
        item-text="name"
        :error="localErrors.idLocal"
        clearable
        item-value="id"
        v-model="localValue.idLocal"
        placeholder="Selecione a localidade" />
      <InputZoom
        :disabled="disabled"
        label="Cidade"
        database="city"
        item-text="name"
        :error="localErrors.idCity"
        clearable
        item-value="id"
        v-model="localValue.idCity"
        placeholder="Selecione a cidade" />
      <InputZoom
        :disabled="disabled"
        label="Lote"
        database="lot"
        item-text="name"
        :error="localErrors.idLot"
        clearable
        item-value="id"
        v-model="localValue.idLot"
        placeholder="Selecione o lote" />
      <TextArea :disabled="disabled" class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira a descrição" :error="localErrors.description" />
    </div>
  </Accordion>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import { get } from '@/crud'
import { useRoute, useRouter } from 'vue-router'

const router = useRoute()
const routeInfo = useRoute()

const type = [
  { label: 'Físico', value: 'physic' },
  { label: 'Equipe', value: 'team' },
  { label: 'Veículo', value: 'vehicles' },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)
const protocolList = ref([])

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
